<template>
  <span class="alignLeft">
    <span v-if="level === 'adset'">
      {{
        typesList.find((v) => v.key == row.campaign_type)
          ? typesList.find((v) => v.key == row.campaign_type).label
          : ''
      }}
    </span>
    <span v-else>
      {{
        typesList.find((v) => v.key == row.type)
          ? typesList.find((v) => v.key == row.type).label
          : ''
      }}
    </span>
  </span>
</template>

<script>
export default {
  name: 'AdTypeCell',
  props: {
    row: {
      type: Object,
      required: true
    },
    level: {
      type: String,
      required: true
    },
    typesList: {
      type: Array,
      required: true
    }
  }
}
</script>